export const GET_CONTENT_CREATOR = "GET_CONTENT_CREATOR";
export const UPDATE_CONTENT_CREATOR_STATUS = "UPDATE_CONTENT_CREATOR_STATUS";
export const DELETE_CONTENT_CREATOR = "DELETE_CONTENT_CREATOR";